import { helpers } from 'vuelidate/lib/validators'
import ConfigService from "../services/ConfigService";

export default maxFileSize =>
  helpers.withParams(
    { type: 'maxFileSize', maxFileSize: maxFileSize },
    function(value, parentVm) {
        if (!value) {
            return true
        } else {
            var maxSize = ConfigService.getMaxFileSize()
            return value.size <= maxSize
        }
    }
  )